<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium"
                    :to="{ name: 'create_broker_account', params: { 'id': this.$route.params.id } }">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{ $t('mannual_proof.text1') }}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{ $t('mannual_proof.text2') }}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{ $t('mannual_proof.text3') }} <span
                            class="bgTitle">{{ $t('mannual_proof.text4') }}</span></h3>
                </div>
            </div>
            <div class="col-12">
                <h4 class="mb-4">{{ $t('personal.text1') }}</h4>
                <Form class="row personalDetails customToolAdd" @submit="submit">
                    <div class="col-12">
                        <div class="countrySelect w-220 form-group position-relative filter-dropdown"
                            :class="[{ 'selected': form.gender }]">
                            <a @click="selectButton2 = !selectButton2" href="javascript:void(0)"
                                class="selectButton d-flex align-items-center justify-content-between">
                                {{ (!form.gender) ? '&nbsp;' : (form.gender == 'M') ? $t('mannual_proof.text17') :
            $t('mannual_proof.text18') }}
                                <vue-feather size="20" type="chevron-down"></vue-feather>
                            </a>
                            <label class="afterSelect">{{ $t('personal.text2') }}</label>
                            <ul class="dropdown_menu_animated scrollable" :class="selectButton2 ? 'show' : ''">
                                <li>
                                    <a href="javascript:void(0)"
                                        @click="form.gender = 'M'; selectButton2 = false">{{ $t('personal.text3') }}</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)"
                                        @click="form.gender = 'F'; selectButton2 = false">{{ $t('personal.text4') }}</a>
                                </li>
                            </ul>
                            <label class="afterSelect">{{ $t('personal.text2') }}</label>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="dualInput d-flex align-items-center">
                            <div class="countrySelect me-3 w-220 form-group position-relative filter-dropdown"
                                :class="[{ 'selected': form.identity }]">
                                <a @click="selectButton = !selectButton" href="javascript:void(0)"
                                    class="selectButton d-flex align-items-center justify-content-between">
                                    {{ (form.identity == '') ? '&nbsp;' : IdentityJson[form.identity] }}
                                    <vue-feather size="20" type="chevron-down"></vue-feather>
                                </a>
                                <!-- <label class="afterSelect">Identity Proof</label> -->
                                <ul class="dropdown_menu_animated scrollable" :class="selectButton ? 'show' : ''">
                                    <li v-for="value, key in IdentityJson" :key="key">
                                        <a href="javascript:void(0)"
                                            @click="form.identity = key; selectButton = false">{{ value }}</a>
                                    </li>
                                </ul>
                                <label class="afterSelect">{{ $t('personal.text5') }}</label>
                            </div>
                            <float-label class="form-group w-460" v-if="form.identity == 1">
                                <Field class="form-control" name="Passport number" :placeholder="$t('personal.text6')"
                                    v-model="form.passportno" rules="required" />
                                <ErrorMessage class="text-danger" name="Passport number" />
                            </float-label>
                            <float-label class="form-group w-460" v-if="form.identity == 2">
                                <Field class="form-control" name="identification number"
                                    :placeholder="$t('personal.text7')" v-model="form.idno" rules="required" />
                                <ErrorMessage class="text-danger" name="identification number" />
                            </float-label>
                            <float-label class="form-group w-460" v-if="form.identity == 3">
                                <Field class="form-control" name="driving license number"
                                    :placeholder="$t('personal.text8')" v-model="form.licenseno" rules="required" />
                                <ErrorMessage class="text-danger" name="driving license number" />
                            </float-label>
                        </div>
                    </div>
                    <div class="col-12" v-if="!store.flavorData?.isEu">
                        <float-label class="form-group w-460">
                            <!-- <input type="text" class="form-control" placeholder="TIN Number" /> -->
                            <Field class="form-control" name="tin number" :placeholder="$t('personal.text9')"
                                v-model="form.tin" rules="required" />
                            <ErrorMessage class="text-danger" name="tin number" />
                        </float-label>
                    </div>
                    <!-- <div class="col-12 mb-2">
                        <div class="dualInput d-flex align-items-center">
                            <div class="countrySelect me-3 w-220 form-group position-relative filter-dropdown"
                                :class="[{ 'selected': DssDigit }]">
                                <a @click="selectButton3 = !selectButton3" href="javascript:void(0)"
                                    class="selectButton d-flex align-items-center justify-content-between">
                                    {{ (!form.dsDigitno && !DssDigit) ? '&nbsp;' : (DssDigit == 1) ?
            $t('mannual_proof.text19') : $t('mannual_proof.text20') }}
                                    <vue-feather size="20" type="chevron-down"></vue-feather>
                                </a>
                                <label class="afterSelect">{{ $t('personal.text10') }}</label>
                                <ul class="dropdown_menu_animated scrollable" :class="selectButton3 ? 'show' : ''">
                                    <li>
                                        <a href="javascript:void(0)"
                                            @click="DssDigit = 1; selectButton3 = false">{{ $t('personal.text11') }}</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"
                                            @click="DssDigit = 2; selectButton3 = false">{{ $t('personal.text12') }}</a>
                                    </li>
                                </ul>
                            </div>
                            <float-label class="form-group w-460" v-if="DssDigit == 1">
                                <Field class="form-control" name="dss digit" :placeholder="$t('personal.text13')"
                                    v-model="form.dsDigitno" rules="required" />
                                <ErrorMessage class="text-danger" name="dss digit" />
                            </float-label>
                        </div>
                    </div> -->
                    <div class="col-12 mb-4">
                        <label class="customCheckBox mb-3">
                            <span class="d-flex align-items-center">{{$t('personal.text14')}}
                                <div class="tooltipbutton openTop">
                                    <span class="tooltiptext f-12">
                                        {{$t('personal.text29')}}
                                        <ul class="dotList mh-250">
                                            <li>{{$t('personal.text30')}}</li>
                                            <li>{{$t('personal.text31')}}</li>
                                            <li>{{$t('personal.text32')}}</li>
                                            <li>{{$t('personal.text33')}}</li>
                                            <li>{{$t('personal.text34')}}</li>
                                            <li>{{$t('personal.text35')}}</li>
                                            <li>{{$t('personal.text36')}}</li>
                                            <li>{{$t('personal.text37')}}</li>
                                            <li>{{$t('personal.text38')}}</li>
                                        </ul>
                                    </span>
                                    <p class="alertNumber d-flex align-items-center mb-0 f-12"><vue-feather size="15" class="flex-shrink-0 smallSize ms-1" type="alert-circle"></vue-feather> </p>
                                </div> 

                            </span>
                           <!--  <Field
                              type="checkbox"
                              class="form-control"
                              name="pep"
                              v-model="form.pep"
                            /> -->
                            <input type="checkbox" class="form-control" name="pep" v-model="form.pep" true-value="true"
                                false-value="false" />
                            <span class="checkmark"></span>
                        </label>
                        <span class="d-flex align-items-center mb-3 smInMob" v-if="store.flavorData?.isEu">
                            {{$t('personal.text15')}}
                            <div class="tooltipbutton openTop">
                                <span class="tooltiptext f-12">
                                    <strong class="mb-1 d-block">{{ $t('personal.text19') }}</strong>
                                    <ul class="dotList mb-0 mh-250">
                                        <li>{{ $t('personal.text20') }}</li>
                                        <li>{{ $t('personal.text21') }}</li>
                                        <li>{{ $t('personal.text22') }}</li>
                                        <li>{{ $t('personal.text23') }}</li>
                                        <li>{{ $t('personal.text24') }}</li>
                                        <li>{{ $t('personal.text25') }}</li>
                                        <li>{{ $t('personal.text26') }}</li>
                                        <li>{{ $t('personal.text27') }}</li>
                                        <li>{{ $t('personal.text28') }} <a class="primary d-block mt-2"
                                                href="http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA"
                                                target="_blank">http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA</a>
                                        </li>
                                    </ul>
                                </span>
                                <p class="alertNumber d-flex align-items-center mb-0 f-12"><vue-feather size="15"
                                        class="flex-shrink-0 smallSize ms-1" type="alert-circle"></vue-feather> </p>
                            </div>
                        </span>
                        <label class="customCheckBox" v-if="!store.flavorData?.isEu">
                            <span class="d-flex align-items-center smInMob">{{ $t('personal.text15') }}
                                <div class="tooltipbutton openTop">
                                    <span class="tooltiptext f-12">
                                        <strong class="mb-1 d-block">{{ $t('personal.text19') }}</strong>
                                        <ul class="dotList mb-0 mh-250">
                                            <li>{{ $t('personal.text20') }}</li>
                                            <li>{{ $t('personal.text21') }}</li>
                                            <li>{{ $t('personal.text22') }}</li>
                                            <li>{{ $t('personal.text23') }}</li>
                                            <li>{{ $t('personal.text24') }}</li>
                                            <li>{{ $t('personal.text25') }}</li>
                                            <li>{{ $t('personal.text26') }}</li>
                                            <li>{{ $t('personal.text27') }}</li>
                                            <li>{{ $t('personal.text28') }} <a class="primary d-block mt-2"
                                                    href="http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA"
                                                    target="_blank">http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA</a>
                                            </li>
                                        </ul>
                                    </span>
                                    <p class="alertNumber d-flex align-items-center mb-0 f-12"><vue-feather size="15"
                                            class="flex-shrink-0 smallSize ms-1" type="alert-circle"></vue-feather> </p>
                                </div>
                            </span>
                            <!-- <Field
                              type="checkbox"
                              class="form-control"
                              name="usperson"
                              v-model="form.usperson"
                            /> -->
                             <input type="checkbox" class="form-control" name="usperson" v-model="form.globalusperson" true-value="true" false-value="false" />
                            <span class="checkmark"></span>
                        </label>
                        <label class="customCheckBox p-0 mt-2" v-if="store.flavorData?.isEu">
                             <div class="d-flex align-items-center mb-2">
                                <label class="customRadio-button position-relative m-0 ps-4 me-2">{{$t('personal.text39')}}
                                    <Field 
                                        type="radio" 
                                        class="form-control" 
                                        value="1" 
                                        v-model="form.usperson" 
                                        name="usperson" 
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <label class="customRadio-button position-relative ps-4 m-0">{{$t('personal.text40')}}
                                    <Field 
                                        type="radio" 
                                        class="form-control" 
                                        value="0" 
                                        v-model="form.usperson"  
                                        name="usperson"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </label>
                        <span v-if="store.flavorData?.isEu && radioRequired" class="text-danger">{{$t('personal_info.text24')}}</span>
                    </div>
                    <div class="col-12 col-md-6" v-if="store.flavorData?.isEu && form.usperson && form.usperson == 0">
                        <div class="countrySelect form-group position-relative filter-dropdown" :class="[{'selected' : form.taxResidence}]">
                            <a @click="selectButton4 = !selectButton4" href="javascript:void(0)"
                                class="selectButton d-flex align-items-center justify-content-between"><span
                                    class="d-flex align-items-center" v-if="form.taxResidence.id && form.taxResidence.name"><img class="me-2" :src="'/assets/images/country_flag/'+form.taxResidence.name.toLowerCase()+'.webp'"
                                        :alt="$t('personal_info.text23')" :title="$t('personal_info.text23')" loading="lazy" width="20" />{{form.taxResidence.name}}</span>
                                        <span v-else>&nbsp;</span>
                                <vue-feather size="20" type="chevron-down"></vue-feather>
                            </a>
                            <label class="afterSelect">{{$t('personal_info.text11')}}</label>
                            <ul class="dropdown_menu_animated scrollable" :class="selectButton4 ? 'show' : ''" > 
                                <li class="form-group mb-1">
                                    <input type="text" :placeholder="$t('personal_info.text8')" class="form-control radius-0" v-model="taxResidenceSearch" />
                                </li>
                                <li v-for="item,key in getCountries" :key="key">
                                    <a href="javascript:void(0)" class="d-flex align-items-center" @click="form.taxResidence = item;selectButton4 = false;taxResidenceSearch = ''" ><img class="me-2"
                                            :src="'/assets/images/country_flag/'+item.name.toLowerCase()+'.webp'" :alt="$t('personal_info.text23')" :title="item.name" loading="lazy" width="20"/>
                                        {{item.name}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 mb-4" v-if="store.flavorData?.isEu && form.usperson && form.usperson == 0">
                        <span class="d-flex align-items-center mb-3" :title="$t('personal.text41')">{{$t('personal.text18')}}</span>
                        <label class="customCheckBox p-0 mt-2">
                             <div class="d-flex align-items-center mb-2">
                                <label class="customRadio-button position-relative m-0 ps-4 me-2">{{$t('personal.text39')}}
                                    <Field 
                                        type="radio" 
                                        class="form-control" 
                                        value="1" 
                                        v-model="form.IsTin" 
                                        name="tin" 
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <label class="customRadio-button position-relative ps-4 m-0">{{$t('personal.text40')}}
                                    <Field 
                                        type="radio" 
                                        class="form-control" 
                                        value="0" 
                                        v-model="form.IsTin"  
                                        name="tin"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </label>
                        <span v-if="tinRequired" class="text-danger">{{$t('personal_info.text24')}}</span>
                    </div>
                    <div class="col-12 col-md-6" v-if="store.flavorData?.isEu && form.usperson == 0 && form.IsTin && form.IsTin == 0">
                            <div class="countrySelect me-3 form-group position-relative filter-dropdown"
                            :class="[{'selected' : form.reason}]">
                                <a @click="selectButton5 = !selectButton5" href="javascript:void(0)"
                                    class="selectButton d-flex align-items-center justify-content-between">
                                    {{(form.reason == '') ? '&nbsp;' : static_vars.jurisdiction_tax_residence_list[form.reason]}}
                                    <vue-feather size="20" type="chevron-down"></vue-feather>
                                </a>
                                <!-- <label class="afterSelect">Identity Proof</label> -->
                                <ul class="dropdown_menu_animated scrollable" :class="selectButton5 ? 'show' : ''">
                                    <li v-for="value,key in static_vars.jurisdiction_tax_residence_list" :key="key">
                                        <a href="javascript:void(0)" @click="form.reason = key;selectButton5 = false">{{value}}</a>
                                    </li>
                                </ul>
                                <label class="afterSelect">{{$t('personal.text17')}}</label>
                            </div>
                    </div>
                    <div class="col-12 col-md-6" v-if="store.flavorData?.isEu && form.usperson == 0 && form.IsTin == 1">
                        <float-label class="form-group w-460">
                            <Field
                              class="form-control"
                              name="tin number"
                              :placeholder="$t('personal.text9')"
                              v-model="form.tin"
                              rules="required"
                            />
                            <ErrorMessage class="text-danger" name="tin number" />
                        </float-label>
                    </div>
                    <div class="col-12 col-md-6" v-if="store.flavorData?.isEu && form.usperson == 0 && form.IsTin == 0 && form.reason == 2">
                        <float-label class="form-group w-460">
                            <Field
                              type="textarea"
                              class="form-control"
                              name="reason"
                              placeholder="Enter Reason"
                              v-model="form.tin_reason"
                              rules="required"
                            />
                            <ErrorMessage class="text-danger" name="reason" />
                        </float-label>
                    </div>
                    <div class="col-12 mb-3">
                        <p class="customAlert position-relative f-13"><i class="alertCircle fa fa-exclamation"
                                aria-hidden="true"></i>{{ $t('personal.text16') }}</p>
                    </div>
                    <div class="col-6">
                        <button type ="submit" class="grd_btn full_size" :class="((!form.gender || !form.identity) || ( store.flavorData?.isEu && form.usperson == 0 ? (form.taxResidence) ? false : true : false))?'disabled' : ''">{{$t('mannual_upload.text13')}}</button>
                    </div>
                </Form>
            </div>
        </div>
    </section>
</template>

<script>
import { useMainStore } from "@/store";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import { Form, Field, ErrorMessage } from "vee-validate";
import moment from 'moment'
import $ from 'jquery'
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            selectButton: false,
            selectButton2: false,
            selectButton3: false,
            selectNumber: false,
            selectButton4 : false,
            selectButton5 : false,
            brokers: false,
            selecServer: false,
            form : {
                gender : '',
                identity : '',
                tin : '',
                passportno : '',
                idno : '',
                licenseno : '',
                dsDigitno : '',
                pep : false,
                usperson : '',
                globalusperson : false,
                taxResidence : '',
                IsTin : '',
                reason : 1,
                tin_reason : 'No TIN is required'

            },
            IdentityJson : {1 : 'Passport Number',2 : 'ID Number',3 : 'Driving License Number'},
            // DssDigit : 2,
            radioRequired : false,
            tinRequired : false,
            taxResidenceSearch : '',

        }
    },
    components: {
        FloatLabel,
        Form,
        Field,
        ErrorMessage,
    },
    computed: {
        getCountries(){
            if(Object.keys(this.store.countryList).length > 0){
                let data = Object.values(this.store.countryList);
                if(this.taxResidenceSearch){
                    return data.filter(item => item.name.toLowerCase().includes(this.taxResidenceSearch.toLowerCase()))
                }else{
                    return data
                }

            }else{
                return []
            }
        }
    },
    mounted() {
        if (Object.keys(this.store.brokerInfo).length) {
            this.form.gender = (this.store.brokerInfo.gender) ? this.store.brokerInfo.gender : ''
            this.form.tin = (this.store.brokerInfo.crs) ? this.store.brokerInfo.crs : ''
            this.form.identity = (this.store.brokerInfo.identity) ? this.store.brokerInfo.identity : ''
            if (parseInt(this.store.brokerInfo.identity) == 1) {
                this.form.passportno = this.store.brokerInfo.p_id
            } else if (parseInt(this.store.brokerInfo.identity) == 2) {
                this.form.idno = this.store.brokerInfo.p_id
            } else if (parseInt(this.store.brokerInfo.identity) == 3) {
                this.form.licenseno = this.store.brokerInfo.p_id
            }
            // this.DssDigit = (this.store.brokerInfo.DssDigit) ? parseInt(this.store.brokerInfo.DssDigit) : ''
            // if (this.store.brokerInfo.DssDigit && parseInt(this.store.brokerInfo.DssDigit) == 1) {
            //     this.form.dsDigitno = this.store.brokerInfo.dssno
            // }
            this.form.pep = (this.store.brokerInfo.pep) ? this.store.brokerInfo.pep : false
            this.form.usperson = (this.store.brokerInfo.usperson) ? this.store.brokerInfo.usperson : false


        }

        const _that = this;
        $(document).on("click", function (event) {
            if (!$(event.target).closest(".filter-dropdown").length) {
                _that.selectButton = false;
                _that.selectButton2 = false;
                _that.selectButton3 = false;
            }
        });
    },
    methods:{
        submit(){
            if(this.form.gender && this.form.identity){
                let formData = {
                    "pid": "",
                    "fname": this.store.brokerInfo.fname,
                    "mname": "",
                    "lname": this.store.brokerInfo.lname,
                    "dob": moment(this.store.brokerInfo.dob).format('YYYY-MM-DD'),
                    "mobile_no": `+${this.store.customerDetail?.phoneCountryCode}${this.store.customerDetail?.phoneNumber.trim()}`,
                    "gender": this.form.gender,
                    "address1": this.store.brokerInfo.address1,
                    "address2": this.store.brokerInfo.address2,
                    "post_code": this.store.brokerInfo.postcode,
                    "nationality": this.store.brokerInfo.nationality.isoCode,
                    "city": this.store.brokerInfo.city,
                    "corr_address1": "",
                    "corr_address2": "",
                    "corr_city": "",
                    "corr_post_code": "",
                    "pep": JSON.parse(this.form.pep),
                    "us_person": JSON.parse(this.form.globalusperson),
                    "crs": this.form.tin || '',
                    "mifir_type": "NIDN",
                    "mifir": '',
                    "idproof": parseInt(this.form.identity)-1,
                    "res_tax": (this.store.flavorData?.isEu) ? this.form.taxResidence?.isoCodeA3 : this.store.brokerInfo.taxResidence.isoCode,
                    "residence_country" : this.store.brokerInfo.country.isoCode,
                }
                //EU Case
                if(this.store.flavorData?.isEu && this.form.usperson){
                    this.radioRequired = false
                    if(this.form.usperson == 0 && this.form.IsTin || this.form.usperson == 1){
                        this.tinRequired = false
                        formData["step"] = "1"
                        formData["usFatca"] = this.form.usperson
                        formData["is_crs"] = this.form.IsTin
                        formData["crs_reason"] = (this.form.IsTin == 0) ?  this.form.reason != 2 ? this.static_vars.jurisdiction_tax_residence_list[this.form.reason]: this.form.tin_reason : this.form.tin
                    }else{
                        this.tinRequired = true
                    }
                }else{
                    this.radioRequired = true
                }
                //finish
                if((parseInt(this.form.identity)-1) == 0){
                    formData['p_id'] = this.form.passportno
                }else if((parseInt(this.form.identity)-1) == 1){
                    formData['p_id'] = this.form.idno
                }else if((parseInt(this.form.identity)-1) == 2){
                    formData['p_id'] = this.form.licenseno
                }
                this.store.brokerInfo['gender'] = this.form.gender
                this.store.brokerInfo['identity'] = this.form.identity
                if(parseInt(this.form.identity) == 1){
                    this.store.brokerInfo['p_id'] = this.form.passportno
                }else if(parseInt(this.form.identity) == 2){
                    this.store.brokerInfo['p_id'] = this.form.idno
                }else if(parseInt(this.form.identity) == 3){
                    this.store.brokerInfo['p_id'] = this.form.licenseno
                }
                this.store.brokerInfo['crs'] = this.form.tin
                // this.store.brokerInfo['DssDigit'] = this.DssDigit
                // if(parseInt(this.DssDigit) == 1){
                //     this.store.brokerInfo['dssno'] = this.form.dsDigitno
                // }
                this.store.brokerInfo['pep'] = JSON.parse(this.form.pep)
                // this.store.brokerInfo['usperson'] = JSON.parse(this.form.usperson)
                if(!this.store.flavorData?.isEu){
                    this.radioRequired = false
                }
                if(!this.radioRequired && !this.tinRequired){
                    this.store.$patch({brokerInfo : this.store.brokerInfo})
                    this.store.saveBrokerPersonalInfo(formData,true,this.$route.params.id,this)
                }
            }
        }
    },
}
</script>
<style>
.disabled {
    pointer-events: none;
    opacity: 0.5;
}
</style>